import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** Extra content rendered to the right of the title (e.g. action buttons) */
  action?: React.ReactNode;
}

/**
 * Seitenkopf der Verwaltung. Auf dem Handy steht die Aktion unter dem Titel und nimmt die volle
 * Breite (`.page-header__aktion`, App.css) — nebeneinander quetschte sie den Titel in zwei Zeilen.
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, action }) => (
  <div className={`${action ? 'page-header flex justify-between items-start' : ''} mb-6 sm:mb-8 animate-fade-up`}>
    <div>
      <h1
        className="text-3xl sm:text-4xl font-extrabold tracking-tight"
        style={{ color: 'var(--text-primary)', letterSpacing: '-0.025em' }}
      >
        {title}
      </h1>
      {subtitle && (
        <p className="mt-1 text-sm" style={{ color: 'var(--text-muted)' }}>
          {subtitle}
        </p>
      )}
    </div>
    {action && <div className="page-header__aktion">{action}</div>}
  </div>
);

export default PageHeader;
